import { render, staticRenderFns } from "./ClearButton.vue?vue&type=template&id=1884ec33&scoped=true&"
import script from "./ClearButton.vue?vue&type=script&lang=js&"
export * from "./ClearButton.vue?vue&type=script&lang=js&"
import style0 from "./ClearButton.vue?vue&type=style&index=0&id=1884ec33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1884ec33",
  null
  
)

export default component.exports